// src/services/OptionsClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const optionsConfig = {
  baseUrl: `${BACK_END_URL}/option`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class OptionsClient extends CandyClient {
  constructor() {
    super(optionsConfig);
  }

  // Get all options for a question
  async getOptionsByQuestionId(questionId) {
    return this.get(`/list/${questionId}`);
  }
  
  // Get a single option by ID
  async getOptionById(optionId) {
    return this.get(`/${optionId}`);
  }


  // Create a new option
  async createOption(optionData) {
    return this.post(`/create`, optionData, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  // Update an option
  async updateOption(optionId, optionData) {
    return this.put(`/update/${optionId}`, optionData, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  // Delete an option
  async deleteOption(optionId) {
    return this.delete(`/delete/${optionId}`, null, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
  }
}